import { lazy } from 'react';

export const SingleAchievement = lazy(() => import('./SingleAchievementWrapper'));
